export default __webpack_public_path__ + "static/media/cake2.5063254d.jpg";